module.exports = __webpack_public_path__ + "static/media/YM44_0.69d605b8.jpg";